module.exports = "/remote-dist/4bf97fe497cdec5261aeea3316d5e749.png";